<template>
  <div class="blueTop">
    <div class="fluid container">
      <div class="commonWhiteBg Vip">
        <a-divider class="topTitle">会员专享特权 全面保护版权</a-divider>
        <vip-block :isVipHome="true" @go-pay="onGoPay"></vip-block>
        <el-table :data="vipConfigList" style="width: 100%">
          <!-- <el-table-column prop="n" label="VIP权益"> </el-table-column>
          <el-table-column prop="s" label="白银会员"> </el-table-column>
          <el-table-column prop="g" label="黄金会员"> </el-table-column>
          <el-table-column prop="d" label="钻石会员"> </el-table-column> -->
        </el-table>
      </div>
    </div>
    <pay-dialog
    ref="payDialog"
      @close="onSetPayDialogClose"
    ></pay-dialog>
  </div>
</template>

<script>
import VipBlock from "../components/VipBlock";
import PayDialog from "../components/PayDialog";
import {applyVip} from '@/api/EvidenceService'
import { mapGetters } from "vuex";
export default {
  name: "Vip",
  components: {
    VipBlock,
    PayDialog,
  },
  data() {
    return {
      isPayDialogVisible: false,
      orderInfo:null,
      tableData: [
        {
          name: "版权存证",
          num1: "5",
          num2: "50",
          num3: "500",
        },
        {
          name: "版权登记",
          num1: "5",
          num2: "50",
          num3: "500",
        },
        {
          name: "实时监测",
          num1: "5",
          num2: "50",
          num3: "500",
        },
        {
          name: "版权取证",
          num1: "5",
          num2: "50",
          num3: "500",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "vipConfig"]),
    vipConfigList: function () {
      let vipConfig = this.vipConfig;
      if (!vipConfig) {
        return [];
      }
      let arr = [];
      let sConfig = vipConfig.S;
      let gConfig = vipConfig.G;
      let dConfig = vipConfig.D;
      arr.push({
        n: "版权存证",
        s: sConfig.existCount,
        g: gConfig.existCount,
        d: dConfig.existCount,
      });
      arr.push({
        n: "版权登记",
        s: sConfig.registerCount,
        g: gConfig.registerCount,
        d: dConfig.registerCount,
      });
      arr.push({
        n: "实时监测",
        s: sConfig.detectCount,
        g: gConfig.detectCount,
        d: dConfig.detectCount,
      });

      arr.push({
        n: "版权取证",
        s: sConfig.obtainCount,
        g: gConfig.obtainCount,
        d: dConfig.obtainCount,
      });

      return arr;
    },
  },
  methods: {
    onGoPay(vipType) {
      let that=this;
      applyVip({
        vipType,
        paymode:'wechat'
      }).then(({data,res})=>{
          that.orderInfo=data;
          that.isPayDialogVisible=true;
           that.$refs.payDialog.showDialog(data);
      });
    },
    onSetPayDialogClose(result) {
      if(result){
           this.bus.$emit('refreshVip');
        this.$router.push({path:'/Mine/Vip'})
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.blueTop {
  background: url("https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/blueBg.svg")
    repeat-x;
  background-size: auto 224px;
  padding-top: 56px;
}
.Vip {
  padding: 72px 56px 56px;
  .topTitle {
    color: rgba(0, 18, 22, 0.65);
    font-size: 32px;
  }
}
@media screen and (min-width: 1200px) {
  .Vip {
    padding: 72px 56px 56px;
  }
  /deep/.VIPBlocks .block .topWrap {
    background-size: auto 100%;
  }
}
@media screen and (min-width: 992px) and (max-width: 1199px) {
  .Vip {
    padding: 72px 56px 56px;
    /deep/.container {
      padding: 0;
    }
    .topTitle {
      font-size: 24px;
    }
  }
  /deep/.VIPBlocks .block .topWrap {
    background-size: auto 100%;
  }
}
@media screen and (min-width: 1px) and (max-width: 991px) {
  .blueTop {
    padding-top: 24px;
  }
  .Vip {
    padding: 24px 16px 8px;
    /deep/.container {
      padding: 0;
    }
    /deep/.ant-col-xl-8 {
      padding: 8px 0;
    }
    .topTitle {
      font-size: 20px;
    }
    .blueTop {
    }
  }

  /deep/.VIPBlocks .block .topWrap {
    background-size: 100% auto;
  }
}
</style>
